import App from './App.vue'
import { createApp } from 'vue'
import VueAxios from 'vue-axios'
import { createPinia } from 'pinia'
import router from './router/index'
import * as Sentry from '@sentry/vue'
import i18n from './translations/index'

// Css
import './index.css'

// Api
import { API } from './api/config'

// App
const app = createApp(App)

Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_URL,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'local',
  integrations: [Sentry.browserTracingIntegration()],
  attachProps: true,
  attachStacktrace: true,
  tracesSampleRate: Number(import.meta.env.VITE_TRACE_SAMPLE_RATE),
  tracePropagationTargets: ['localhost', 'heypongo.com', /^\//],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
})

app.use(createPinia())
app.use(VueAxios, API)
app.use(i18n)
app.use(router).mount('#app')

if (import.meta.env.VITE_SENTRY_URL) {
  app.config.errorHandler = (error, instance, info) => {
    Sentry.captureException(error, {
      extra: {
        componentName: instance?.$.type.name,
        info,
      },
    })
  }
}
